import {
  globalGetService,
  globalPutService,
  globalPostService,
  globalGetServiceV2,
} from '../../../utils/globalApiServices';
import {
  convertTimeWithTimezone,
  getTimezone,
  US_DATE_FORMAT,
} from '../../../utils/time';

export function getCampaignDetailApi(campaignUid) {
  return globalGetService(`mno/campaigns/${campaignUid}`).then((response) => {
    if (response?.ok) {
      const campaign = response.data;
      campaign.createDate = convertTimeWithTimezone(
        campaign.createDate,
        undefined,
        US_DATE_FORMAT
      );
      return campaign;
    }
  });
}

export function findAllVerticalsApi() {
  globalGetService('enums/verticalTypes').then((response) => {
    if (response.status >= 200 && response.status < 300) {
      this.generateOptions(response.data, 'vertical');
    }
  });
}

export function updateCampaignStatusApi(campaignUid, body = {}) {
  return globalPutService(`mno/campaigns/${campaignUid}/status`, body);
}

export function fileComplaintApi(campaignUid, body) {
  return globalPostService(`mno/campaigns/${campaignUid}/complaint`, body);
}

export const queryCampaignPhoneNumbers = async (id, query = {}) => {
  const response = await globalGetServiceV2(
    `mno/campaigns/${id}/phoneNumbers`,
    query,
    { silent: true }
  );
  if (response && response.ok) {
    return response.data;
  }
  return null;
};

export const getCampaignPhoneNumbersOnly = async (campaignUid, query = {}) => {
  const response = await globalGetServiceV2(
    `mno/campaigns/${campaignUid}/phoneNumbersOnly`,
    {
      ...query,
    }
  );
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    return null;
  }
};

export const downloadCampaignPhoneNumbers = async (campaignUid, query = {}) => {
  const response = await globalGetService(
    `mno/campaigns/${campaignUid}/phoneNumbers/csv`,
    { ...query, timezone: getTimezone() },
    { responseType: 'arraybuffer' }
  );
  if (response && response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    return null;
  }
};

export const updateBulkCampaignStatusApi = async (body = {}) => {
  const response = await globalPutService(`mno/campaigns/status`, body);
  if (response?.ok) {
    return true;
  }
};

export function getCampaignEventsListApi(query = {}) {
  return globalGetService('mno/event', query).then((response) => {
    if (response?.ok) {
      const eventInfo = response.data;
      return eventInfo;
    }
  });
}

export const getCampaignAttachmentsApi = async (campaignUid, folder) => {
  const response = await globalGetService(
    `mno/attachments/campaign/${campaignUid}?folder=${encodeURIComponent(
      folder
    )}`
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const downloadAttachmentApi = async (attachmentUuid) => {
  const response = await globalGetService(
    `mno/attachments/download?attachmentUuid=${encodeURIComponent(
      attachmentUuid
    )}`,
    {},
    { responseType: 'arraybuffer' }
  );
  if (response.status >= 200 && response.status < 300) {
    return response.data;
  }
};

export const getCampaignSharingChain = async (campaignUid) => {
  const response = await globalGetService(
    `mno/campaigns/${campaignUid}/sharingChain`
  );
  if (response?.ok) {
    return response.data;
  }
};

export const getCampaignMigrationInfo = async (
  campaignId,
  config = { silent: false }
) => {
  const reqUrl = `mno/campaigns/${campaignId}/migrateCnp`;
  const response = await globalGetService(
    reqUrl,
    {},
    { silent: config.silent }
  );

  if (response.ok) {
    return response.data;
  }
};

export const fetchBrandSuggestions = (query = {}) =>
  globalGetService('mno/brands/suggestions', { ...query, limit: 20 }).then(
    (response) =>
      response?.ok ? response.data?.map((d) => d?.brandName) ?? [] : []
  );

export const fetchCspSuggestions = (query = {}) =>
  globalGetService('mno/csp/suggestions', { ...query, limit: 20 }).then(
    (response) =>
      response?.ok ? response.data?.map((d) => d?.cspName) ?? [] : []
  );
